<mat-dialog-content id="modalV" class="modal-dialog modal-lg p-0">
  <div class="modal-content">
    <div class="modal-header blue">
      <h2 class="modal-title white fs-5">{{ 'modal.title_edit_rating' | translate }}</h2>
      <span class="dismiss-modal white" (click)="dialogRef.close()">X</span>
    </div>
    <div class="modal-body">
      <div class="col-12 pb-3">
        <p>Valoración:</p>
        <textarea class="w-100 mb-3" rows="5" [(ngModel)]="detailV">{{ detailV() }}</textarea>
        <!-- <hr /> -->
        <button class="white d-block m-auto" (click)="close()">Actualizar</button>
      </div>
    </div>
  </div>
</mat-dialog-content>
